var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "show_box" }, [
      _c("div", { staticClass: "box_item" }, [
        _c("p", { staticClass: "title" }, [_vm._v("参与总客户")]),
        _c("p", { staticClass: "num" }, [_vm._v(_vm._s(_vm.joinAllCount))]),
        _c("p", { staticClass: "today" }, [
          _vm._v("今日：" + _vm._s(_vm.joinTodayCount)),
        ]),
      ]),
      _c("div", { staticClass: "box_item" }, [
        _c("p", { staticClass: "title" }, [_vm._v("总新增客户")]),
        _c("p", { staticClass: "num" }, [_vm._v(_vm._s(_vm.addAllCount))]),
        _c("p", { staticClass: "today" }, [
          _vm._v("今日：" + _vm._s(_vm.addTodayCount)),
        ]),
      ]),
      _c("div", { staticClass: "box_item" }, [
        _c("p", { staticClass: "title" }, [_vm._v("总流失客户")]),
        _c("p", { staticClass: "num" }, [_vm._v(_vm._s(_vm.deleteAllCount))]),
        _c("p", { staticClass: "today" }, [
          _vm._v("今日：" + _vm._s(_vm.deleteTodayCount)),
        ]),
      ]),
      _c("div", { staticClass: "box_item" }, [
        _c("p", { staticClass: "title" }, [_vm._v("总获奖客户")]),
        _c("p", { staticClass: "num" }, [_vm._v(_vm._s(_vm.winAllCount))]),
        _c("p", { staticClass: "today" }, [
          _vm._v("今日：" + _vm._s(_vm.winTodayCount)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }